import NewStaticTable from 'components/staticTable/NewStaticTable'
import Modal from 'global/Modal/Modal'
import CustomPaginate from 'global/Pagination/CustomPaginate'
import SimpleButton from 'global/SimpleButton/SimpleButton'
import { useState } from 'react'
import { BiTrash } from 'react-icons/bi'
import { SharePercentFromColumn, SharePercentFromColumn2 } from './Columns'

interface TableItem {
  from: number
  to: number
  percentage: number
  id?: number 
}

interface SharePercentTableProps {
  tableData: TableItem[]
  onDelete: (index: number) => void
  type?:number
}

function SharePercentTable({ tableData, onDelete,type }: SharePercentTableProps) {

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [itemToDelete, setItemToDelete] = useState<number | null>(null)
  const [currentList, setCurrentList] = useState<TableItem[]>([])

  const handleDeleteClick = (index: number) => {
    setItemToDelete(index)
    setIsModalOpen(true)
  }

  const confirmDelete = () => {
    if (itemToDelete !== null) {
      onDelete(itemToDelete)
    }
    setIsModalOpen(false)
    setItemToDelete(null)
  }

  const data = tableData.map((item, index) => ({
    ...item,
    
    operation: (
      <button
        className='border-none text-[14px] w-[20px] h-[20px] hover:text-red-500 transition-colors'
        onClick={() => handleDeleteClick(index)}
        aria-label='Delete item'
        type='button'
      >
        <BiTrash size={20} className='w-full h-full' />
      </button>
    ),
  }))

  return (
    <div className='mt-10 min-w-[20rem]'>
      <NewStaticTable
        data={currentList}
        THWrapper='whitespace-nowrap'
        column={![1,2].includes(type) ? SharePercentFromColumn:SharePercentFromColumn2}
      />

      <Modal
        visible={isModalOpen}
        setVisible={setIsModalOpen}
        title='حذف آیتم'
        // onClose={() => setItemToDelete(null)}
      >
        <p className='text-center py-4'>آیا از حذف این مورد اطمینان دارید؟</p>
        <div className='flex w-full justify-center gap-4 mt-5'>
          <SimpleButton
            text='خیر'
            className='full-lightTomato-btn w-28'
            handelClick={() => setIsModalOpen(false)}
          />
          <SimpleButton
            text='بله'
            className='full-tomato-btn w-28'
            handelClick={confirmDelete}
            type='button'
          />
        </div>
      </Modal>

      {tableData.length >= 0 && (
        <CustomPaginate
          tableData={data}
          totalElements={data.length}
          currentList={currentList}
          setCurrentLists={setCurrentList}
          itemsPerPage={6} 
        />
      )}
    </div>
  )
}

export default SharePercentTable
